import script from "./UiQrcode.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiQrcode.vue?vue&type=script&lang=ts&setup=true"

import "./UiQrcode.vue?vue&type=style&index=0&id=ef17101a&scoped=true&lang=css"

import exportComponent from "/home/ni/IdeaProjects/pioneer/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef17101a"]])

export default __exports__